var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('span',{staticClass:"badge",class:{ compact: _vm.compact, animate: _vm.animate },domProps:{"innerHTML":_vm._s(_vm.highlightedLabel)},on:{"click":function($event){return _vm.$emit('click', $event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }